// extracted by mini-css-extract-plugin
module.exports = {"map-container":"WorldColoredMap_map-container__3_SCf","popup":"WorldColoredMap_popup__3qyxp","title":"WorldColoredMap_title__1SGWD","icon":"WorldColoredMap_icon__3z4oa"};